import React, { useState } from 'react';
import SectionHotelTitle from '../../../components/SectionTitle/SectionTitle';
import SectionTitle from '../../yourProperties/Title';
import Card from '../../../../muiComponents/Card';
import { imageColumnGrid } from '../../../../utils/bookings/bookingUtils';
import StarRating from './StarRating';
import Title from '../../../components/Title';
import Icon from '../../../../muiComponents/Icon';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import Image from '../../../components/Image';
import useTranslate from '../../../../customHooks/useTranslate';
import IconButton from '../../../../muiComponents/IconButton';
import routes from '../../../../utils/commonVariables/routes';
import { Tooltip } from '@mui/material';
import {
    gridSpacing20,
    gridSpacing30,
} from '../../../../utils/commonVariables/grid';

const HotelInfo = props => {
    const { hotel, rating, hotelCategory, address, hotelImages, idHotel } =
        props;
    const translate = useTranslate();

    const [isVisibleSection, setIsVisibleSection] = useState(true);

    return (
        <section className='booking__section'>
            <div
                className={`flex flex-between flex-align-baseline ${
                    !isVisibleSection ? 'border-color-bottom' : ''
                }`}
            >
                <SectionTitle text={translate('hotel')} />
                <IconButton
                    iconName={isVisibleSection ? 'ExpandLess' : 'ExpandMore'}
                    onClick={() => setIsVisibleSection(!isVisibleSection)}
                />
            </div>
            {isVisibleSection ? (
                <Card className='booking__card padding20 flex-column gap-20'>
                    <div className='flex flex-align-center flex-between padding15'>
                        <div className='flex-column gap-5'>
                            <Tooltip titleText='navigate_to_hotel_detail'>
                                <span
                                    onClick={e => {
                                        e.stopPropagation();
                                        const linkToHotel =
                                            routes.propertyDetail(idHotel);

                                        window.open(linkToHotel, linkToHotel);
                                    }}
                                >
                                    <SectionHotelTitle
                                        title={hotel}
                                        className='text-capitalize cursor-pointer text-secondary-700  link-onhover'
                                    />
                                </span>
                            </Tooltip>
                            <StarRating rating={rating} title={hotelCategory} />
                        </div>
                        <div className='flex-column flex-align-end gap-5'>
                            <div className='flex flex-align-center gap-5 text-overflow-ellipsis'>
                                <Icon
                                    iconName='LocationOnOutlined'
                                    className='text-secondary-700'
                                />

                                <Title className='text-capitalize'>
                                    {translate('address')}
                                </Title>
                            </div>
                            <p className='text-align-end'>{address}</p>
                        </div>
                    </div>
                    <Grid
                        columnSpacing={gridSpacing30}
                        rowSpacing={gridSpacing20}
                        style={{ width: 'unset' }}
                        className='padding15'
                    >
                        {hotelImages.map((img, ind) => (
                            <GridChild
                                gridProps={imageColumnGrid}
                                key={img?.id || ind}
                            >
                                <Image
                                    className='booking__image'
                                    src={img?.virtualPath || ''}
                                    useLocalBaseUrl={false}
                                />
                            </GridChild>
                        ))}
                    </Grid>
                </Card>
            ) : (
                ''
            )}
        </section>
    );
};

export default HotelInfo;
